<ix-application>
  <ix-application-header [name]="applicationName()">
    <user-auth slot="ix-application-header-avatar" />
  </ix-application-header>
  <ix-menu
    enableToggleTheme="true"
    [i18nLegal]="'NAVIGATION.ABOUT_AND_LEGAL' | translate"
    [i18nSettings]="'NAVIGATION.SETTINGS' | translate"
  >
    <ix-menu-item icon="home" routerLink="/">{{
      "NAVIGATION.HOMEPAGE" | translate
    }}</ix-menu-item>

    <!-- Settings -->
    <ix-menu-settings>
      <settings />
    </ix-menu-settings>

    <!-- About and legal -->
    <ix-menu-about [label]="'NAVIGATION.ABOUT_AND_LEGAL' | translate">
      <about-info />
    </ix-menu-about>
  </ix-menu>
  <ix-content>
    <router-outlet />
  </ix-content>
</ix-application>
